import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Title from '../Components/Title';

const Deficiencia = ({ loading, funcionario = {}, onSubmit }) => {
  const defaultValues = {
    rotina: 'PessoalDeficiencia',
    entidade_id: funcionario?.entidade_id,
    fisica: null,
    visual: null,
    auditiva: null,
    mental: null,
    intelectual: null,
    readaptado: null,
    preenchecotas: null,
    observacao: '',
  };
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    if (funcionario?.Deficiencia) {
      const merged = Object.keys(defaultValues).reduce((acc, key) => {
        acc[key] = funcionario?.Deficiencia[key] ?? defaultValues[key];
        return acc;
      }, {});
      reset(merged);
    }
  }, [funcionario, reset]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title title="Deficiências" disableMargin />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="fisica"
          label="Física"
          control={control}
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="visual"
          label="Visual"
          control={control}
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="auditiva"
          label="Auditiva"
          control={control}
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Dropdown
          name="mental"
          label="Mental"
          control={control}
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Dropdown
          control={control}
          name="intelectual"
          label="Intelectual"
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Dropdown
          control={control}
          name="readaptado"
          label="Readaptado"
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Dropdown
          label="Cotista"
          control={control}
          name="preenchecotas"
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          rows={3}
          multiline
          name="observacao"
          control={control}
          label="Observação"
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          color="primary"
          variant="contained"
          loading={loading}
          onClick={handleSubmit(onSubmit)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Deficiencia;
